import { ProbeEventStatus } from '@/modules/stats/availability/domain/probe-event/status/probe-event-status.js';

export class UnavailableStatus extends ProbeEventStatus {
  getTranslateTextKey() {
    return 'stats.availability.status.unavailable';
  }

  getBackgroundColor() {
    return this.critical ? 'bg-error' : 'bg-orange-500';
  }

  getTextColor() {
    return this.critical ? 'text-error' : 'text-orange-500';
  }

  getOutlineColor() {
    return this.critical ? 'outline-error' : 'outline-orange-500';
  }
}
